import { Component } from '@angular/core';

@Component({
  selector: 'app-remove-big',
  templateUrl: './remove-big.component.html',
  styleUrls: ['./remove-big.component.scss']
})
export class RemoveBigComponent {

}
